module.exports = __webpack_public_path__ + "img/polar-logo.1cc80241.jpg";